import React, { useCallback, useEffect, useState, useRef } from "react";
import * as Mui from "@mui/material";
import { checkEditorPermission } from "services/utils/HelperFunction";
import { Loader } from "components/Loader";
import { showToast } from "services/utils/Status";
import { useSelector } from "react-redux";
import { GlobalDialogBox } from "components/GlobalDialogBox";
import { Info, Edit, Delete } from "@mui/icons-material";
import { CustomButton } from "components/CustomComponents/CustomButton";
import { TableEmptyState } from "components/CustomComponents/EmptyState";
import { useForm } from "react-hook-form";
import { customGetAPI, customAPI } from "services/utils/CustomAPI";
import sessionHandling from "services/utils/notificationUtils";
import { employmentTypeHeader } from "pages/Administration/AdministrationHeaders";
import { tooltipStyleProps } from "services/constants/Styles";
import {
  themes,
  tableHeaderSx,
  tableRowSx,
  tableCellFontSize,
  scrollTop,
} from "services/constants";
import { formKeyText } from "services/constants/Styles";
export const EmploymentType = () => {
  const { domain, token, globalSearchValue, userScreenAccess } = useSelector(
    (state) => state.tokenReducer
  );
  const [page, setPage] = useState(0);
  let check_access = checkEditorPermission(
    userScreenAccess?.module_details,
    "Master",
    "Employment Type"
  );
  const [fetchEmploymentTypeData, setFetchEmploymentTypeData] = useState(true);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [employmentData, setEmploymentData] = useState([]);
  const [loader, setLoader] = useState(false);
  const [edit, setEdit] = useState([]);
  const [etype, setEtype] = useState("");
  const [openDialog, setOpenDialog] = useState(false);
  const [buttonLoader, setButtonLoader] = useState(false);
  const tableContainerRef = useRef(null);
  const [tableHeight, setTableHeight] = useState(window.innerHeight * 0.75);

  useEffect(() => {
    const updateHeight = () => {
      setTableHeight(window.innerHeight * 0.75);
    };

    window.addEventListener("resize", updateHeight);

    return () => window.removeEventListener("resize", updateHeight);
  }, []);
  useEffect(() => {
    scrollTop(tableContainerRef);
  }, [page]);
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const [masterEmployementList, setMasterEmployementList] = useState([]);
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const checkExistingEmploymentType = useCallback(
    async (e_type) => {
      const res = await customGetAPI(
        `${domain}check/employment-type?employment_name=${e_type}`
      );
      if (res.ok) {
        if (res?.responseDetails?.exists) {
          return "Employment type is already exists";
        } else {
          return true;
        }
      }
    },
    [domain]
  );

  const addEmploymentType = useCallback(
    async (employmentType, description) => {
      const response = await customAPI(`${domain}employment-type/`, "POST", {
        employment_type: employmentType,
        description: description,
      });
      if (response.ok) {
        showToast("success", "Employment type added.");
        setFetchEmploymentTypeData(true);
      } else {
        setFetchEmploymentTypeData(true);
      }
    },
    [domain]
  );

  const updateEmploymentType = useCallback(
    async (employmentType, description) => {
      const response = await customAPI(
        `${domain}employment-type/${edit?.id}`,
        "PUT",
        {
          employment_type: employmentType,
          description: description,
        }
      );
      if (response.ok) {
        showToast("success", "Employment type updated.");
        setFetchEmploymentTypeData(true);
      } else {
        setFetchEmploymentTypeData(true);
      }
    },
    [domain, edit?.id]
  );

  const removeEmploymentType = useCallback(async () => {
    try {
      const response = await fetch(`${domain}employment-type/${edit?.id}`, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Authorization: `token ${token}`,
        },
        body: JSON.stringify({
          isdeleted: "true",
        }),
      });
      await response.json();
      if (response.ok) {
        showToast("success", "Employment type deleted.");
      } else if (response.status === 409) {
        sessionHandling();
      } else {
        throw new Error('REQUEST_FAILED');
      }
    } catch (error) {
      console.error('[Employmenttype] operation failed:', error);
      showToast("error", "Couldn't save the details. Please try again.");
    } finally {
      setFetchEmploymentTypeData(true);
    }
  }, [domain, edit?.id, setFetchEmploymentTypeData, token]);

  const fetchEmploymentDatas = useCallback(async () => {
    setLoader(true);
    const res = await customGetAPI(`${domain}employment-type/`);
    if (res.ok) {
      setEmploymentData([]);
      setEmploymentData(res?.responseDetails?.results);
      setMasterEmployementList(res?.responseDetails?.results);
      setLoader(false);
    } else {
      setLoader(false);
    }
    setLoader(false);
  }, [domain]);

  useEffect(() => {
    setFetchEmploymentTypeData(true);
  }, [setFetchEmploymentTypeData]);

  useEffect(() => {
    if (fetchEmploymentTypeData) {
      fetchEmploymentDatas();
      setFetchEmploymentTypeData(false);
      setButtonLoader(false);
      setOpenDialog(false);
      setEtype("");
    }
  }, [
    fetchEmploymentDatas,
    fetchEmploymentTypeData,
    setFetchEmploymentTypeData,
  ]);
  useEffect(() => {
    if (etype !== "") {
      setOpenDialog(true);
    }
  }, [etype]);

  useEffect(() => {
    const searchFields = ["employment_type", "description"];
    const filteredResults = masterEmployementList.filter((item) =>
      searchFields.some((key) =>
        item[key]
          ?.toString()
          .toLowerCase()
          .includes(globalSearchValue.toString().toLowerCase())
      )
    );
    setEmploymentData(filteredResults);
    setPage(globalSearchValue ? 0 : page);
  }, [globalSearchValue, masterEmployementList, page]);

  const moveToAddEmploymentType = () => {
    setEtype("Add");
  };

  return (
    <React.Fragment>
      <EtypeDialog
        type={etype}
        setEtype={setEtype}
        edit={edit}
        openDialog={openDialog}
        setOpenDialog={setOpenDialog}
        addEmploymentType={addEmploymentType}
        updateEmploymentType={updateEmploymentType}
        removeEmploymentType={removeEmploymentType}
        checkExistingEmploymentType={checkExistingEmploymentType}
        buttonLoader={buttonLoader}
        setButtonLoader={setButtonLoader}
      />
      <Mui.Grid
        container
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "flex-end",
          alignItems: "flex-end",
          paddingTop: 2,
          paddingRight: 1,
        }}
      >
        <CustomButton
          actionFuntion={() => {
            if (check_access) {
              moveToAddEmploymentType();
            } else {
              showToast(
                "error",
                `Access denied: You are not authorized to add employment type`
              );
            }
          }}
          actionName="Add Employment Type"
          typeName="button"
        />
      </Mui.Grid>
      {loader ? (
        <Loader info="Loading..." />
      ) : (
        <Mui.Grid container>
          <Mui.TableContainer
            sx={{
              mt: 2,
              width: "100%",
              ml: 2,
              mlr: 2,
              maxHeight: tableHeight,
            }}
            ref={tableContainerRef}
          >
            <Mui.Table className="border">
              <Mui.TableHead sx={tableHeaderSx}>
                <Mui.TableRow maxWidth="xl" align="left" sx={tableRowSx}>
                  {employmentTypeHeader?.map?.((value) => (
                    <Mui.TableCell
                      sx={{ color: themes.headLine, fontWeight: "bold" }}
                    >
                      {value?.name}
                    </Mui.TableCell>
                  ))}
                </Mui.TableRow>
              </Mui.TableHead>
              <Mui.TableBody>
                {employmentData?.length === 0 && !loader ? (
                  <TableEmptyState dataLength={masterEmployementList} />
                ) : (
                  employmentData
                    ?.slice(
                      page * rowsPerPage,
                      page * rowsPerPage + rowsPerPage
                    )
                    ?.map((item) => (
                      <Mui.TableRow
                        key={item?.id}
                        maxWidth="xl"
                        align="left"
                        sx={tableRowSx}
                      >
                        <Mui.TableCell></Mui.TableCell>
                        <Mui.TableCell
                          sx={{
                            color: themes.headLine,
                            fontSize: tableCellFontSize,
                          }}
                        >
                          {item?.employment_type
                            ? item?.employment_type
                            : "N/A"}
                        </Mui.TableCell>
                        <Mui.TableCell
                          sx={{
                            color: themes.headLine,
                            fontSize: tableCellFontSize,
                            paddingRight: 2,
                          }}
                        >
                          {item?.description?.length > 50
                            ? item?.description.substr(0, 50) + "..."
                            : item?.description
                            ? item?.description?.length > 50
                              ? item?.description.substr(0, 50) + "..."
                              : item?.description
                            : "N/A"}
                        </Mui.TableCell>
                        <Mui.TableCell
                          sx={{
                            color: themes.headLine,
                            fontSize: tableCellFontSize,
                          }}
                        >
                          <Mui.IconButton
                            onClick={() => {
                              if (check_access) {
                                setEdit([]);
                                setEdit(item);
                                setEtype("Edit");
                              } else {
                                showToast(
                                  "error",
                                  "Access denied: You are not authorized to add department"
                                );
                              }
                            }}
                          >
                            <Edit />
                          </Mui.IconButton>
                          <Mui.IconButton
                            onClick={() => {
                              if (check_access) {
                                setEdit([]);
                                setEdit(item);
                                setEtype("Delete");
                              } else {
                                showToast(
                                  "error",
                                  "Access denied: You are not authorized to add department"
                                );
                              }
                            }}
                          >
                            <Delete />
                          </Mui.IconButton>
                        </Mui.TableCell>
                      </Mui.TableRow>
                    ))
                )}
              </Mui.TableBody>
            </Mui.Table>
          </Mui.TableContainer>
        </Mui.Grid>
      )}
      {employmentData?.length > 25 ? (
        <Mui.TablePagination
          className="custom-pagination"
          component="div"
          rowsPerPageOptions={[25, 50, 75, 100]}
          count={employmentData?.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      ) : null}
    </React.Fragment>
  );
};

export default function EtypeDialog({
  type,
  setEtype,
  edit,
  openDialog,
  setOpenDialog,
  addEmploymentType,
  updateEmploymentType,
  removeEmploymentType,
  checkExistingEmploymentType,
  buttonLoader,
  setButtonLoader,
}) {
  const {
    register,
    reset,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({ mode: "onBlur" });

  const handleClose = useCallback(() => {
    setOpenDialog(false);
    setEtype("");
    setValue("e_type", "");
    setValue("description", "");
    reset();
  }, [reset, setEtype, setOpenDialog, setValue]);

  useEffect(() => {
    if (type === "Add") {
      setValue("e_type", "");
      setValue("description", "");
      reset();
    } else if (type === "Edit") {
      reset();
      setValue("e_type", edit?.employment_type);
      setValue("description", edit?.description);
    } else if (type === "Delete") {
      setValue("e_type", "");
      setValue("description", "");
      reset();
    }
  }, [edit?.description, edit?.employment_type, reset, setValue, type]);

  const onSubmit = async (data) => {
    try {
      setButtonLoader(true);
      setTimeout(() => null, 1000);
      if (data) {
        if (type === "Add") {
          await addEmploymentType(data?.e_type, data?.description);
        } else if (type === "Edit") {
          await updateEmploymentType(data?.e_type, data?.description);
        } else if (type === "Delete") {
          await removeEmploymentType();
        }
      }
    } finally {
      handleClose();
    }
  };

  const checkSpecialChar = (e) => {
    if (!/[a-zA-Z ]/.test(e.key)) {
      e.preventDefault();
    }
  };

  const checkSpecialCharWithDigits = (e) => {
    if (!/[a-zA-Z\d ]/.test(e.key)) {
      e.preventDefault();
    }
  };
  return (
    <GlobalDialogBox
      key={type}
      handleCloseDialog={handleClose}
      open={openDialog}
      title={
        type === "Delete"
          ? "Delete Employment Type"
          : type === "Add"
          ? "Add Employment Type"
          : "Edit Employment Type"
      }
      minWidth={650}
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        {type === "" ? null : type === "Delete" ? (
          <Mui.Grid container>
            <Mui.Grid xs={12}>
              <Mui.Typography sx={{ fontSize: 22, paddingBottom: 2 }}>
                Do you want to remove the employment type?
              </Mui.Typography>
            </Mui.Grid>
            <Mui.Grid xs={12}>
              <Mui.Stack
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "flex-end",
                  alignItems: "flex-end",
                }}
              >
                <CustomButton
                  actionFuntion={handleClose}
                  actionName="No"
                  typeName="submit"
                />
                &nbsp;&nbsp;
                <CustomButton
                  key={buttonLoader}
                  actionName="Yes"
                  typeName="submit"
                  disableAction={buttonLoader}
                />
              </Mui.Stack>
            </Mui.Grid>
          </Mui.Grid>
        ) : (
          <>
            <Mui.Grid container sx={{ paddingBottom: 1 }}>
              <Mui.Grid xs={4.5} sx={{ justifyContent: "flex-start" }}>
                <Mui.Stack
                  direction="Row"
                  sx={{
                    paddingTop: 1,
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "start",
                    alignItems: "flex-start",
                    paddingRight: 1,
                  }}
                >
                  <Mui.Typography sx={formKeyText}>
                    Employment Type &nbsp;
                    <Mui.Tooltip
                      arrow
                      slotProps={tooltipStyleProps}
                      title="Employment type is refers to the different type of workers a company may contract with or hire for employment.            "
                    >
                      <Info />
                    </Mui.Tooltip>
                  </Mui.Typography>
                </Mui.Stack>
              </Mui.Grid>
              <Mui.Grid xs={7.5}>
                <Mui.TextField
                  placeholder="Enter the employment type"
                  {...register("e_type", {
                    required: "Employment Type is required",
                    minLength: {
                      value: 3,
                      message: "Minimum 3 characters are required",
                    },
                    validate: {
                      employmentType: async (fieldValue) => {
                        if (fieldValue.trim().length < 3) {
                          return "Minimum 3 characters are required";
                        } else if (type === "Add" && !buttonLoader) {
                          return checkExistingEmploymentType(fieldValue.trim());
                        } else if (
                          edit?.employment_type !== fieldValue &&
                          !buttonLoader
                        ) {
                          return checkExistingEmploymentType(fieldValue.trim());
                        } else {
                          return true;
                        }
                      },
                    },
                  })}
                  onKeyPress={checkSpecialChar}
                  size="small"
                  InputProps={{
                    inputProps: { maxLength: 32 },
                  }}
                  error={Boolean(errors.e_type)}
                  helperText={errors.e_type?.message || ""}
                  fullWidth
                />
              </Mui.Grid>
            </Mui.Grid>
            <Mui.Grid container sx={{ paddingBottom: 1 }}>
              <Mui.Grid xs={4.5} sx={{ justifyContent: "flex-start" }}>
                <Mui.Stack
                  direction="Row"
                  sx={{
                    paddingTop: 1,
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "start",
                    alignItems: "flex-start",
                    paddingRight: 1,
                  }}
                >
                  <Mui.Typography sx={formKeyText}>
                    Description &nbsp;
                    <Mui.Tooltip
                      arrow
                      slotProps={tooltipStyleProps}
                      title="Here, you  can add more Information  about the flexibility and operation it offers for that type of employee..            "
                    >
                      <Info />
                    </Mui.Tooltip>
                  </Mui.Typography>{" "}
                </Mui.Stack>
              </Mui.Grid>
              <Mui.Grid xs={7.5}>
                <Mui.TextField
                  multiline={true}
                  rows={3}
                  placeholder="Enter the description"
                  {...register("description", {
                    required: "Description is required",
                    minLength: {
                      value: 3,
                      message: "Minimum 3 characters are required",
                    },
                    validate: {
                      employmentTypeDescription: async (fieldValue) => {
                        if (fieldValue.trim().length < 3) {
                          return "Minimum 3 characters are required";
                        } else {
                          return true;
                        }
                      },
                    },
                  })}
                  size="small"
                  InputProps={{
                    inputProps: { maxLength: 128 },
                  }}
                  onKeyPress={checkSpecialCharWithDigits}
                  error={Boolean(errors.description)}
                  helperText={errors.description?.message || ""}
                  fullWidth
                />
              </Mui.Grid>
              <Mui.Grid xs={1}></Mui.Grid>
            </Mui.Grid>
            <Mui.Stack
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-end",
                alignItems: "flex-end",
              }}
            >
              <CustomButton
                actionFuntion={handleClose}
                actionName="Cancel"
                typeName="submit"
              />
              &nbsp;&nbsp;
              <CustomButton
                key={buttonLoader}
                actionName={type === "Add" ? "Add" : "Update"}
                typeName="submit"
                disableAction={buttonLoader}
              />
            </Mui.Stack>
          </>
        )}
      </form>
    </GlobalDialogBox>
  );
}
